/**
 * Created by jonas on 2022-06-15.
 */
import {SimplePresentation, SimplePresentationRunnerController} from "../winpresentation/SimplePresentationRunner";
import {KitchenDramaSushiMania} from "../KitchenDramaSushiMania";
import {AvalancheWinInfo, BetLineWinData} from "../server/KitchenDramaSushiManiaData";
import {KitchenDramaSushiManiaSymbol, KitchenDramaSushiManiaSymbolStates} from "../reels/KitchenDramaSushiManiaSymbol";
import {GSAPUtils} from "../utils/GSAPUtils";
import {gsap} from "gsap";
import {StateMatrix} from "../utils/StateMatrix";
import {KitchenDramaSushiManiaReelsView} from "../reels/KitchenDramaSushiManiaReelsView";
import {KitchenDramaSushiManiaGameMode} from "../server/KitchenDramaSushiManiaGameMode";

export class SushiFreespinCollectPresentation implements SimplePresentation {
    name:string = "SushiFreespinCollectPresentation";
    private roundIndex:number;

    constructor(index:number) {
        this.roundIndex = index;
    }

    shouldRun():boolean {
        const correctMode = KitchenDramaSushiMania.model.data.mode == KitchenDramaSushiManiaGameMode.WILD_SUSHI;
        const hasChange = KitchenDramaSushiMania.model.gameData.avalancheWinInfo[this.roundIndex].sushiModeCollectedWinsAfterSpin != KitchenDramaSushiMania.model.gameData.avalancheWinInfo[this.roundIndex].sushiModeCollectedWinsBeforeSpin;
        return correctMode && hasChange;
    }

    start(controller:SimplePresentationRunnerController):void {
        const collectedCount:number = KitchenDramaSushiMania.model.gameData.avalancheWinInfo[this.roundIndex].sushiModeCollectedWinsAfterSpin;
        const contributingSymbols = this.findContributingSymbols(KitchenDramaSushiMania.model.gameData.betLineWins[this.roundIndex]);

        const tl:gsap.core.Timeline = gsap.timeline({onComplete:() => controller.finish()});
        tl.add(KitchenDramaSushiMania.sushiFsMeterView.updateLevelAnimation(collectedCount, contributingSymbols));

    }

    private findContributingSymbols(betlines:BetLineWinData[]):boolean[] {
        let result:boolean[] = [false, false, false];
        if(betlines && betlines.length > 0) {
            for(let i:number = 0; i < betlines.length; i++) {
                let betLine:any = betlines[i];

                if(betLine.symbol == "L2") {
                    result[0] = true;
                }

                else if(betLine.symbol == "M4") {
                    result[1] = true;
                }
                else if(betLine.symbol == "M1") {
                    result[2] = true;
                }
            }
        }

        return result;
    }
}